<ng-container *ngIf="group">
    <tr *ngIf="group.components" 
    class="group-toggle" 
    [attr.depth]="depth">        
        <td (click)="toggleClass($event,'expanded')">
            <span class="d-flex align-items-center">
                <i class="far fa-angle-down"></i> {{group.title ? group.title : (group.label ? group.label : group.name)}}
            </span>
        </td>
        <td *ngFor="let registration of registrations"
        (click)="onGroupClick(registration, group.components)">
            <i class="fas fa-check" *ngIf="childrensContain(registration.registrationId, group.components)"></i>
        </td>
    </tr>
    <tbody *ngIf="group.components">
        <fields-group 
            *ngFor="let g of group.components;"
            [group]="g"
            [registrations]="registrations"
            [depth]="depth + 1"
            (onRelationChange)="editFieldRegistrationEvent($event)"
            (onToggleGroup)="onToggleGroup.emit($event)">
        </fields-group>
    </tbody>
    <tr *ngIf="!group.components"
    [attr.depth]="depth">
        <td>{{group.title ? group.title : (group.label ? group.label : group.name)}}</td>
        <td *ngFor="let registration of registrations;" 
        (click)="editFieldRegistrationEvent({registration: registration, group: group, done: false});"
        class="field-reg-rel">
            <span class="cursor-pointer">
                <i class="fas fa-check" *ngIf="getIncludes(group.registrations, registration.registrationId)"></i>
            </span>
        </td>
    </tr>
</ng-container>